import React from "react";
import "./Footer.css";

const pageFooter = (
  <footer className="site-footer">
    <p>
      <span className="footer-highlight">GadgetHub.cse23.org</span>
      {" "}— All tools run locally in your browser. No servers. No third-party access.
    </p>
    <p className="footer-sub">
      Special thanks to all contributors of GadgetHub on GitHub{" "}
      <span className="footer-heart">♥</span>
    </p>
  </footer>
);

export default pageFooter;
